/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';
import { find as _find } from 'lodash';

import type {
  CreateProductionParams,
  UpdateProductionParams,
  Production,
  LiferayError,
} from 'types';

const find = async (): Promise<Production[]> => {
  const endpoint = '/protones-portlet.produzioni/find-all-by-organization';
  const response = await callLiferayEndpoint(endpoint, {});
  return response.map(utils.toProduction);
};

const get = async (id: number): Promise<Production[]> => {
  const production = await find().then(productions => _find(productions, p => id === p.id));
  if (production === undefined) {
    const error: LiferayError = { code: 'NOT_FOUND', message: 'Oggetto non trovato' };
    throw error;
  } else {
    return production;
  }
};

const create = async (params: CreateProductionParams): Promise<Production> => {
  const createParams = {
    produzione: {
      nomeProduzione: params.name, // "nomeProduzione": "Cielo che goal",
      edizione: params.edition, // "edizione": "",
      quantitaProduzione: params.quantity || 0, // "areaId": -1,
      areaId: params.areaId || 0, // "areaId": -1,
      produttoreId: params.producerId, // "produttoreId": 0,
      produttore: params.producerName, // "produttore": "Sound Records snc",
      tipologiaProduzioneId: params.productionTypeId || 0, // "tipologiaProduzioneId": 1,
    },
  };
  const endpoint = '/protones-portlet.produzioni/add';
  const response = await callLiferayEndpoint(endpoint, createParams);
  return utils.toProduction(response);
};

const update = async (params: UpdateProductionParams): Promise<Production> => {
  const liferayParams = {
    produzione: {
      produzioneId: params.id, // "produzioneId": 4801,
      areaId: params.areaId || 0, // "areaId": -1,
      edizione: params.edition, // "edizione": "",
      nomeProduzione: params.name, // "nomeProduzione": "Cielo che goal",
      tipologiaProduzioneId: params.productionTypeId || 0, // "tipologiaProduzioneId": 1,
      produttoreId: params.producerId, // "produttoreId": 0,
      quantitaProduzione: params.quantity, // "quantitaProduzione": -1,
    },
  };
  const response = await callLiferayEndpoint('/protones-portlet.produzioni/update', liferayParams);
  return utils.toProduction(response);
};

const _delete = async (id: number): Promise<any> => {
  const endpoint = '/protones-portlet.produzioni/delete';
  await callLiferayEndpoint(endpoint, { produzioneId: id });
};

export default {
  find,
  get,
  create,
  update,
  delete: _delete,
};
